import { AgmCoreModule } from '@agm/core';

import { UploadModule } from './../../shared/modules/upload/upload.module';
import { SharedModule } from './../../shared/shared.module';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ProfileRoutingModule } from './profile-routing.module';
import { ProfileListingComponent } from './pages/profile-listing/profile-listing.component';
import { ProfileDetailsComponent } from './pages/profile-details/profile-details.component';
import { MyOrdersComponent } from './pages/my-orders/my-orders.component';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MyAddressComponent } from './pages/my-address/my-address.component';
import { AddAddressComponent } from './components/add-address/add-address.component';
import { MembershipComponent } from './pages/membership/membership.component';
import { MyFavouritesComponent } from './pages/my-favourites/my-favourites.component';
import { MyEnquiriesComponent } from './pages/my-enquiries/my-enquiries.component';
import { OrdersDetailsComponent } from './pages/orders-details/orders-details.component';
import { ProfileService } from './services/profile.service';
import { SupportCenterComponent } from './pages/support-center/support-center.component';
import { RenewMembershipComponent } from './components/renew-membership/renew-membership.component';
import { DeleteAddressComponent } from './components/delete-address/delete-address.component';
import { CatFavService } from './services/cat-fav.service';
import { RatingRemarkComponent } from './components/rating-remark/rating-remark.component';
import { CancelOrderComponent } from './components/cancel-order/cancel-order.component';
import { RaiseSupportComponent } from './components/raise-support/raise-support.component';
import { MyEnquiriesDetailsComponent } from './pages/my-enquiries-details/my-enquiries-details.component';
import { AccountPayComponent } from './pages/account-pay/account-pay.component';
import { AddAccountPayComponent } from './components/add-account-pay/add-account-pay.component';
import { AddSupplierAccountRequestComponent } from './components/add-supplier-account-request/add-supplier-account-request.component';
import { CancelOrderItemComponent } from './components/cancel-order-item/cancel-order-item.component';
import { NgxMatSelectSearchModule } from 'ngx-mat-select-search';
import { MyBidsComponent } from './pages/my-bids/my-bids.component';
import { MyPreOwnedOrdersComponent } from './pages/my-pre-owned-orders/my-pre-owned-orders.component';
import { PreOwnedOrdersDetailsComponent } from './pages/pre-owned-orders-details/pre-owned-orders-details.component';
import { SingleFavoriteProductComponent } from './components/single-favorite-product/single-favorite-product.component';
import { VerifyOtpComponent } from './pages/verify-otp/verify-otp.component';
import { DeleteSupplierAccountComponent } from './components/delete-supplier-account/delete-supplier-account.component';
import { SecondHandRequestComponent } from './components/second-hand-request/second-hand-request.component';
import { SupplyRequestComponent } from './components/supply-request/supply-request.component';
import { JobListingComponent } from './pages/job-listing/job-listing.component';
import { JobPostComponent } from './pages/job-post/job-post.component';
import { PostnewJob } from './services/job-section.service';
import { ApplicantDetailsComponent } from './pages/applicant-details/applicant-details.component';
import { FollowListingComponent } from './pages/follow-listing/follow-listing.component';
import { JobDetailsPreviewComponent } from './pages/job-details-preview/job-details-preview.component';
import { AppliedJobsListingComponent } from './pages/applied-jobs-listing/applied-jobs-listing.component';
import { TalentListingComponent } from './pages/talent-listing/talent-listing.component';
import { EnquiriesJobsListingComponent } from './pages/enquiries-jobs-listing/enquiries-jobs-listing.component';
import { SwiperModule } from 'ngx-swiper-wrapper';
import { CourseListingComponent } from './pages/course-listing/course-listing.component';
import { CoursePostComponent } from './pages/course-post/course-post.component';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';
import { ScrollingModule } from '@angular/cdk/scrolling';
import { CourseDetailsPreviewComponent } from './pages/course-details-preview/course-details-preview.component';
import { CourseRegisterComponent } from './pages/course-register/course-register.component';
import { RegisteredCourseComponent } from './pages/registered-course/registered-course.component';
import { MatDialogModule } from '@angular/material/dialog';
import { JobApplicantsComponent } from './pages/job-applicants/job-applicants.component';
import { TalentEnquiriesComponent } from './pages/talent-enquiries/talent-enquiries.component';

//import { ApplicantInfoComponent } from '../jobseek/pages/applicant-info/applicant-info.component';
// import { LoginComponent } from '../home/components/login/login.component';
// import { MatDialogModule } from '@angular/material/dialog';

@NgModule({
  declarations: [
    ProfileListingComponent,
    ProfileDetailsComponent,
    MyOrdersComponent,
    MyAddressComponent,
    AddAddressComponent,
    MembershipComponent,
    MyFavouritesComponent,
    MyEnquiriesComponent,
    OrdersDetailsComponent,
    SupportCenterComponent,
    RenewMembershipComponent,
    DeleteAddressComponent,
    MyEnquiriesDetailsComponent,
    RatingRemarkComponent,
    CancelOrderComponent,
    RaiseSupportComponent,
    AccountPayComponent,
    AddAccountPayComponent,
    AddSupplierAccountRequestComponent,
    CancelOrderItemComponent,
    MyBidsComponent,
    MyPreOwnedOrdersComponent,
    PreOwnedOrdersDetailsComponent,
    SingleFavoriteProductComponent,
    VerifyOtpComponent,
    DeleteSupplierAccountComponent,
    SecondHandRequestComponent,
    SupplyRequestComponent,
    JobListingComponent,
    JobPostComponent,
    ApplicantDetailsComponent,
    FollowListingComponent,
    JobDetailsPreviewComponent,
    AppliedJobsListingComponent,
    TalentListingComponent,
    EnquiriesJobsListingComponent,
    CourseListingComponent,
    CoursePostComponent,
    CourseDetailsPreviewComponent,
    CourseRegisterComponent,
    RegisteredCourseComponent,
    JobApplicantsComponent,
    TalentEnquiriesComponent,


    //ApplicantInfoComponent
  ],
  imports: [
    CommonModule,
    ProfileRoutingModule,
    SharedModule,
    MatDatepickerModule,
    UploadModule,
    NgxMatSelectSearchModule,
    AgmCoreModule,
    SwiperModule,
    InfiniteScrollModule,
    ScrollingModule,
    MatDialogModule
  ],
  providers: [ProfileService, CatFavService, PostnewJob],
  exports: [FollowListingComponent]
  //entryComponents: [LoginComponent]
})
export class ProfileModule { }
